module.exports = __webpack_public_path__ + "static/media/item1.a1f08f99.jpg";